export default __webpack_public_path__ + "static/media/football-player-image.9ce832a7.png";